import React from 'react'

import {PageHeader} from '@/components/molecules'
import {PageContainer} from '@/components/organisms'
import PromotionsList from '@/containers/Promotions/PromotionList'


const PromotionsListPage = () => {
  return (
    <div>
      <div className="flex flex-row justify-between">
        <PageHeader title={'Promotions'} />
      </div>
      <PageContainer data-testid="promotions-list-page-content">
        <PromotionsList />
      </PageContainer>
    </div>
  )
}

export default PromotionsListPage
